const hexToDec = (hex: string = 'FF') => {
  let result = 0;
  for (let i = 0; i < hex.length; i++) {
    result = result * 16 + '0123456789abcdefgh'.indexOf(hex[i].toLowerCase());
  }
  return result;
};

export const middleColor = (color1: string, color2: string, ratioValue: number) => {
  const ratio = isNaN(ratioValue) ? 1 : ratioValue;
  const c1 = color1.replace('#', '').match(/.{1,2}/g) as string[];
  const c2 = color2.replace('#', '').match(/.{1,2}/g) as string[];
  const factor1 = 1 - ratio;

  const [rr, gg, bb, aa] = new Array(4)
    .fill(null)
    .map((_, i) => parseInt(String(hexToDec(c1[i]) * factor1 + hexToDec(c2[i]) * ratio)));

  return '#' + [rr, gg, bb, aa].map((v) => `0${v.toString(16)}`.slice(-2)).join('');
};

export const OTHER_COLOR = '#D9D9D9';
export const COLOR_START = '#009FDF';
export const COLOR_END = '#0028A0';
